module.exports = __webpack_public_path__ + "static/media/thumbnail.78783e1d.jpg";